import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BoardMap } from '../components/board/map/board.Map';
import { ModalGlobal } from '../components/modal/modal.Global';
import { saveMany } from '../store/items';
import { setOpenModales } from '../store/global';

const E2E_ITEM_ID = '111111111111111111111111';
const E2E_BOARD_ID = '222222222222222222222222';
const BLOCKING_MODAL_ID = `map-grid-settings-${E2E_BOARD_ID}`;

const BlockingBoardModal = ({ onUnmount }) => (
  <ModalGlobal
    idToOpen={BLOCKING_MODAL_ID}
    title='Modale board E2E'
  >
    <p>Modale board bloquante E2E</p>
    <button
      type='button'
      className='mt-1 rounded bg-primary px-1 py-05'
      onClick={onUnmount}
    >
      Démonter modale board
    </button>
  </ModalGlobal>
);

const BlockingModalState = () => {
  const isOpen = useSelector(
    state => state.global.openModales?.[BLOCKING_MODAL_ID] === true,
  );

  return (
    <div
      className='fixed right-1 top-10 z-10000 rounded bg-main-d px-1 py-05 text-xs'
      data-testid='e2e-map-blocking-modal-state'
    >
      {isOpen ? 'open' : 'closed'}
    </div>
  );
};

const BoardMapStateProbe = ({ viewport, mapTool, interactionMode }) => {
  const shapeCount = useSelector(
    state => state.items?.[E2E_BOARD_ID]?.map?.shapes?.length || 0,
  );
  const [selectionCounts, setSelectionCounts] = React.useState({
    pins: 0,
    links: 0,
    shapes: 0,
    regions: 0,
    drawings: 0,
    widgets: 0,
    groups: 0,
  });

  React.useEffect(() => {
    window.__setE2EBoardMapSelectionCounts = setSelectionCounts;
    return () => {
      delete window.__setE2EBoardMapSelectionCounts;
    };
  }, []);

  return (
    <div className='fixed right-1 top-16 z-10000 rounded bg-main-d px-1 py-05 text-xs'>
      <div data-testid='e2e-map-shape-count'>{shapeCount}</div>
      <div data-testid='e2e-map-selected-shape-count'>
        {selectionCounts.shapes}
      </div>
      <div data-testid='e2e-map-viewport'>
        {Math.round(Number(viewport?.x) || 0)},{Math.round(Number(viewport?.y) || 0)}
      </div>
      <div data-testid='e2e-map-tool'>{mapTool}</div>
      <div data-testid='e2e-map-interaction-mode'>{interactionMode}</div>
    </div>
  );
};

const E2EBoardMap = () => {
  const dispatch = useDispatch();
  const [zoom, setZoom] = React.useState(1);
  const [viewport, setViewport] = React.useState({ x: 0, y: 0, zoom: 1 });
  const [mapTool, setMapTool] = React.useState('select');
  const [interactionMode, setInteractionMode] = React.useState('pan');
  const [showBlockingModal, setShowBlockingModal] = React.useState(false);

  React.useEffect(() => {
    dispatch(
      saveMany({
        log: 'e2e-board-map',
        items: [
          {
            _id: E2E_ITEM_ID,
            label: 'Board E2E',
            type: 'character',
            campaign: 'none-visitor',
            world: 'none-visitor',
            universe: 'none-visitor',
            tabs: [
              {
                [E2E_BOARD_ID]: {
                  _id: E2E_BOARD_ID,
                  label: 'Tableau blanc',
                  display: 'map',
                },
              },
            ],
          },
          {
            _id: E2E_BOARD_ID,
            label: 'Tableau blanc',
            type: 'tab',
            campaign: 'none-visitor',
            world: 'none-visitor',
            universe: 'none-visitor',
            grid: [],
            map: {
              viewport: { x: 0, y: 0, zoom: 1 },
              grid: {
                visible: true,
                size: 50,
                color: 'contrast',
                opacity: 0.18,
              },
              pins: [
                {
                  id: 'pin-1',
                  x: 240,
                  y: 180,
                  color: 'secondary',
                  size: 'md',
                },
              ],
              shapes: [
                {
                  id: 'shape-1',
                  type: 'rect',
                  x: 360,
                  y: 240,
                  w: 160,
                  h: 100,
                  stroke: 'main-d',
                  borderStyle: 'solid',
                },
                {
                  id: 'shape-2',
                  type: 'rect',
                  x: 540,
                  y: 250,
                  w: 130,
                  h: 90,
                  stroke: 'secondary',
                  borderStyle: 'solid',
                },
              ],
              regions: [],
              drawings: [],
              links: [],
              groups: [],
              measurements: [],
            },
          },
        ],
      }),
    );
    [
      `map-measure-settings-${E2E_BOARD_ID}`,
      `map-pin-link-${E2E_BOARD_ID}`,
      `map-background-${E2E_BOARD_ID}`,
      `map-grid-settings-${E2E_BOARD_ID}`,
      'passwords',
    ].forEach(id => {
      dispatch(setOpenModales({ id, open: false }));
    });
  }, [dispatch]);

  return (
    <div className='h-screen w-screen bg-main text-contrast'>
      <button
        type='button'
        className='fixed left-1 top-1 z-10000 rounded bg-primary px-1 py-05 text-xs'
        onClick={() => {
          setShowBlockingModal(true);
          dispatch(setOpenModales({ id: BLOCKING_MODAL_ID, open: true }));
        }}
      >
        Ouvrir modale board
      </button>
      <button
        type='button'
        className='fixed left-1 top-10 z-10000 rounded bg-primary px-1 py-05 text-xs'
        onClick={() => {
          setInteractionMode('pan');
          setMapTool('select');
        }}
      >
        Mode pan E2E
      </button>
      <button
        type='button'
        className='fixed left-1 top-16 z-10000 rounded bg-primary px-1 py-05 text-xs'
        onClick={() => {
          setInteractionMode('select');
          setMapTool('select');
        }}
      >
        Mode sélection E2E
      </button>
      <button
        type='button'
        className='fixed left-1 top-24 z-10000 rounded bg-primary px-1 py-05 text-xs'
        onClick={() => {
          setInteractionMode('select');
          setMapTool('shape');
        }}
      >
        Outil shape E2E
      </button>
      <div
        className='fixed right-1 top-1 z-10000 rounded bg-main-d px-1 py-05 text-xs'
        data-testid='e2e-map-zoom'
      >
        {Math.round(zoom * 100)}%
      </div>
      <BlockingModalState />
      <BoardMapStateProbe
        viewport={viewport}
        mapTool={mapTool}
        interactionMode={interactionMode}
      />
      {showBlockingModal && (
        <>
          <button
            type='button'
            className='fixed left-1 top-5 z-20000 rounded bg-secondary px-1 py-05 text-xs'
            data-testid='e2e-unmount-blocking-board-modal'
            onClick={() => setShowBlockingModal(false)}
          >
            Démonter modale board externe
          </button>
          <BlockingBoardModal onUnmount={() => setShowBlockingModal(false)} />
        </>
      )}
      <BoardMap
        itemId={E2E_ITEM_ID}
        boardId={E2E_BOARD_ID}
        boardWidth={1200}
        editable={true}
        layoutEditable={true}
        onZoomChange={setZoom}
        onViewportChange={setViewport}
        interactionMode={interactionMode}
        mapTool={mapTool}
        measureMode='measure'
        mapShapeType='rect'
        onSelectionCountsChange={counts => {
          window.__setE2EBoardMapSelectionCounts?.(counts);
        }}
      />
    </div>
  );
};

export default E2EBoardMap;
